export default __webpack_public_path__ + "static/media/bed.00a6adfd.svg";